// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_1DHfe","item_wrap":"item_wrap_1vrBW","item_tag":"item_tag_iUNjz","item_1":"item_1_LmrSO","item_2":"item_2_3RaUy","item_3":"item_3_2AtOf"};